module.exports = __webpack_public_path__ + "img/tech_13.9d511795.jpg";